import type React from "react";

export type FileInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "className" | "type"> & {
  ref?: React.Ref<HTMLInputElement>;
};

/** A native file chooser kept visually hidden so its owning label or media surface can trigger it. */
export function FileInput({ ref, ...props }: FileInputProps): React.ReactNode {
  return <input {...props} ref={ref} className="sr-only" type="file" />;
}
